'use client';

import { freddyTheme, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement, ReactNode } from 'react';

import { openInternalPopup } from '../../utils/internalPopup';

export default function VanessaInsurancesIconButton({
  url,
  index,
  totalIndices,
  children
}: {
  url: string;
  index: number;
  totalIndices: number;
  children: ReactNode;
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <IconButton
      size='small'
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'view_insurances_vanessa',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'vanessa_insurances',
            attribute: 'vanessa_insurances'
          })
        );
        openInternalPopup(url);
      }}
      sx={{
        padding: freddyTheme.spacing[200]
      }}
    >
      {children}
    </IconButton>
  );
}
